

import autoComplete from "@tarekraafat/autocomplete.js";

class ZoneLivraison {
  private form: HTMLFormElement | null;
  private inputElement?: HTMLInputElement | null;
  private readonly inputId = 'code_postal_search';
  private popinOK?: HTMLElement | null;
  private popinKO?: HTMLElement | null;
  private hasValidSelection: boolean = false;

  constructor() {
    this.form = document.querySelector<HTMLFormElement>('.zone-livraison__form');
    this.inputElement = this.form?.querySelector<HTMLInputElement>(`#code_postal_search`);
    this.popinOK = document.querySelector<HTMLElement>(`.popin[data-popin="ok"]`);
    this.popinKO = document.querySelector<HTMLElement>(`.popin[data-popin="ko"]`);
    if (!this.inputElement) {
      return;
    }
    this.initAutoComplete();
    this.form!.addEventListener('submit', this.handleSubmit.bind(this));
  }

  // --- Gestion de l'état de sélection ---
  public setSelectionStatus(status: boolean): void {
    this.hasValidSelection = status;
    console.log(`Statut de sélection mis à jour : ${status}`);
  }


  private handleSubmit(event: Event): void {
    event.preventDefault();
    if (this.inputElement!.value.trim() === '') {
      this.hasValidSelection = false;
    }
    const targetInputs = document.querySelectorAll<HTMLInputElement>('input[name="zone"]');
    targetInputs.forEach(input => {
      input.value = this.inputElement!.value;
      input.readOnly = true;
      console.log(`Valeur '${this.inputElement!.value}' transférée à input[name="${input.name}"].`);
    });
    if (this.hasValidSelection) {
      console.log("Vérification OK: Ouverture de la popin 'ok'.");
      this.popinOK!.classList.add('active');
      document.body.classList.add('unscrollable');
    } else {
      console.log("Vérification KO: Ouverture de la popin 'ko'.");
      this.popinKO!.classList.add('active');
      document.body.classList.add('unscrollable');
    }
  }


  private initAutoComplete(): void {
    if (!this.inputElement) {
      return;
    }
    const zonesJsonString = this.inputElement.dataset.zones;

    if (!zonesJsonString) {
      return;
    }

    let zoneDataArray: string[] = [];

    zoneDataArray = JSON.parse(zonesJsonString);
    const autoCompleteJS = new autoComplete({
      selector: `#${this.inputId}`,
      placeHolder: "Ex : 59176",
      data: {
        src: zoneDataArray,
        key: ["*"],
      },
      resultItem: {
        highlight: true
      },
      events: {
        input: {
          selection: (event) => {
            const selection = event.detail.selection.value;
            autoCompleteJS.input.value = selection;
            this.setSelectionStatus(true);
            autoCompleteJS.close();
          },
          blur: (event) => {
            this.checkInputValueAgainstData(zoneDataArray);
          },
        }
      }
    });
  }

  private checkInputValueAgainstData(dataList: string[]): void {
    if (!this.inputElement) return;
    const rawInput = this.inputElement.value.trim().toLowerCase();
    // Si l'entrée est vide après le nettoyage, c'est forcément invalide
    if (rawInput === '') {
      this.setSelectionStatus(false);
      console.log(`Vérification BLUR : Saisie vide.`);
      return;
    }
    let foundMatch = false;
    const regex = /^(.+)\s\(([0-9]{5})\)$/i; // Le /i rend la recherche insensible à la casse

    for (const zoneEntry of dataList) {
      // Exécute la regex sur l'entrée complète de la liste
      const match = zoneEntry.match(regex);

      if (match) {
        const listCity = match[1].toLowerCase().replace(/[^a-z]/g, '').trim(); // "Ville"
        const listPostalCode = match[2];                                      // "Code postal"
        // 1. L'utilisateur a-t-il saisi le code postal exact ?
        if (rawInput === listPostalCode) {
          foundMatch = true;
          break;
        }

        // 2. L'utilisateur a-t-il saisi le nom de la ville (même partielle) ?
        // On normalise la ville saisie pour la comparer à la ville de la liste.
        const inputCityNormalized = rawInput.replace(/[^a-z]/g, '').trim();

        if (inputCityNormalized === listCity) {
          foundMatch = true;
          break;
        }

        // 3. Vérification si l'utilisateur a saisi toute la chaîne (comportement par défaut)
        if (rawInput === zoneEntry.toLowerCase()) {
          foundMatch = true;
          break;
        }
      }
    }

    if (foundMatch) {
      this.setSelectionStatus(true);
    } else {
      this.setSelectionStatus(false);
    }
  }
}

document.addEventListener('DOMContentLoaded', () => {
  new ZoneLivraison();
});